import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'luxonDate',
  standalone: true,
})
export class LuxonDatePipe implements PipeTransform {
  transform(value: DateTime | string | Date, format: string = 'medium'): string {
    if (!value) {
      return '';
    }

    let dt: DateTime;

    if (value instanceof DateTime) {
      dt = value;
    } else {
      // Attempt to parse from string or native Date
      dt = DateTime.fromISO(value.toString());
      if (!dt.isValid) {
        dt = DateTime.fromJSDate(new Date(value));
      }
    }

    if (!dt.isValid) {
      console.warn('Invalid date value for LuxonDatePipe:', value);
      return '';
    }

    switch (format) {
      case 'medium':
      case 'mediumDate':
        return dt.toLocaleString(DateTime.DATE_MED); // e.g., "Oct 27, 2023"
      case 'longDate':
        return dt.toLocaleString(DateTime.DATE_HUGE); // e.g., "Friday, October 27, 2023"
      case 'datetime':
        return dt.toLocaleString(DateTime.DATETIME_MED); // e.g., "Oct 27, 2023, 10:00 AM"
      case 'short':
      case 'shortDate':
        return dt.toLocaleString(DateTime.DATE_SHORT);
      default:
        return dt.toFormat(format); // e.g., 'MM/dd/yyyy'
    }
  }
}